import { NgModule }       from '@angular/core';
import { ModalService } from '../root/modal/modal.service';
import {CompanyServiceA2} from "./company_a2.service";
import {LoadingWheelService} from "../root/loading/loading-wheel.service";
import {SessionService} from "./session.service";
import {SidebarService} from "../root/sidebar/sidebar.service";
import {NotificationService} from "../root/toast/notification.service";
import {LogoutService} from "./logout.service";
import {InformationModalService} from "../root/information-modal/information-modal.service";
import {FormModalService} from "../root/form-modal/form-modal.service";
import {BackgroundColorService} from "../root/background-color/background-color.service";
import {GAService} from "../root/ga/ga.service";
import {ErrorLogService} from "./error-log.service";
import {NewRelicService} from "./newrelic.service";
import {AuthenticateUserService} from "./authenticate-user.service";
import {ValidatorService} from "./validator.service";
import {ContractService} from "./contract.service";
import {GeoServiceA2} from "./geo_a2.service";
import {AlfredA2Service} from "./alfred.service";
import {GeoCodeService} from "./geo-code.service";
import {LoggerService} from "./logger.service";
import {ConsoleLoggerService} from "./console-logger.service";
import {VersionCheckService} from "./version-check.service";
import {NavigationService} from "../root/sara-header/navigation.service";
import {EmailValidatorService} from "./email-validator.service";
import {LegalDocumentService} from "./legal_document_service";
import {ContractStatesService} from "./contract_states.service";

@NgModule({
    providers: [AuthenticateUserService, ModalService, CompanyServiceA2, LoadingWheelService, SessionService, SidebarService,
        InformationModalService, NotificationService, LogoutService, BackgroundColorService, GAService, ErrorLogService,
        NewRelicService, ValidatorService, FormModalService, ContractService, GeoServiceA2, VersionCheckService,
        AlfredA2Service, GeoCodeService, NavigationService, EmailValidatorService,
        LegalDocumentService, ContractStatesService, { provide: LoggerService, useClass: ConsoleLoggerService }]
})
export class CoreModule {}



// WEBPACK FOOTER //
// ./public/upgrade/core/core.module.ts